import { render, staticRenderFns } from "./DataInheritInput.vue?vue&type=template&id=1d569243&scoped=true"
import script from "./DataInheritInput.vue?vue&type=script&lang=js"
export * from "./DataInheritInput.vue?vue&type=script&lang=js"
import style0 from "./DataInheritInput.vue?vue&type=style&index=0&id=1d569243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d569243",
  null
  
)

export default component.exports